/* eslint-disable react/no-find-dom-node */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactDOM from 'react-dom';
import { Flag } from 'semantic-ui-react';
import { colors } from '../utils/colors';

class MultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.dropdownRef = null;
    this.dropdownButton = null;
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  handleCheckboxChange = (itemId) => {
    const { selectedItems, setSelectedItems } = this.props;

    if (selectedItems.includes(itemId)) {
      setSelectedItems(selectedItems.filter((id) => id !== itemId));
    } else {
      setSelectedItems([...selectedItems, itemId]);
    }
  };

  handleClickOutside = (e) => {
    const dropdownNode = ReactDOM.findDOMNode(this.dropdownRef);
    const buttonNode = ReactDOM.findDOMNode(this.dropdownButton);

    if (
      dropdownNode &&
      buttonNode &&
      !dropdownNode.contains(e.target) &&
      !buttonNode.contains(e.target)
    ) {
      this.setState({ isOpen: false });
    }
  };

  handleSelectAll = () => {
    const { items, selectedItems, setSelectedItems } = this.props;

    if (selectedItems.length === items.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(items.map((item) => item.id));
    }
  };

  render() {
    const { items, selectedItems, placeholder, width, maxHeight } = this.props;
    const { isOpen } = this.state;

    const isAllSelected = selectedItems.length === items.length;

    return (
      <MultiSelectContainer width={width}>
        <MultiSelectButton
          ref={(button) => {
            this.dropdownButton = button;
          }}
          onClick={this.toggleDropdown}
          isOpen={this.state.isOpen}
        >
          {placeholder}
          {isOpen ? (
            <i className="delete icon" />
          ) : (
            <i className="dropdown icon" />
          )}
        </MultiSelectButton>

        {isOpen && (
          <MultiSelectDropdown
            ref={(dropdown) => {
              this.dropdownRef = dropdown;
            }}
            maxHeight={maxHeight}
          >
            <MultiSelectList>
              {items && items.length > 0 && (
                <MultiSelectItem key="all">
                  <label>
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={this.handleSelectAll}
                      className="checkbox"
                    />
                    Select All
                  </label>
                </MultiSelectItem>
              )}

              {items && items.length > 0 ? (
                items.map((item) => (
                  <MultiSelectItem key={item.id}>
                    <label>
                      <input
                        type="checkbox"
                        checked={selectedItems.includes(item.id)}
                        onChange={() => this.handleCheckboxChange(item.id)}
                        className="checkbox"
                      />
                      {item.region && <Flag name={item.region} />}
                      {item.name}
                    </label>
                  </MultiSelectItem>
                ))
              ) : (
                <MultiSelectItem>No accounts available</MultiSelectItem>
              )}
            </MultiSelectList>
          </MultiSelectDropdown>
        )}
      </MultiSelectContainer>
    );
  }
}

MultiSelect.propTypes = {
  items: PropTypes.array.isRequired,
  selectedItems: PropTypes.array.isRequired,
  setSelectedItems: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  width: PropTypes.string,
  maxHeight: PropTypes.string,
};

MultiSelect.defaultProps = {
  placeholder: 'Select Items',
  width: '',
  maxHeight: '',
};

export default MultiSelect;

const MultiSelectContainer = styled.div`
  position: relative;
  display: inline-block;
  width: ${(props) => props.width || '100%'};
`;

const MultiSelectButton = styled.button`
  width: 100%;
  padding: 10px;
  font-size: 14px;
  cursor: pointer;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: left;
  position: relative;
  color: '#aaa';
  display: flex;
  justify-content: space-between;

  &:hover {
    border-color: #999;
  }

  &:focus {
    outline: none;
    border-color: ${colors.teal};
  }
`;

const MultiSelectDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: ${(props) => props.maxHeight || '170px'};
  overflow-y: scroll;
  border: 1px solid ${colors.teal};
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  margin-top: 4px;
`;

const MultiSelectList = styled.div`
  padding: 0;
  margin: 0;
`;

const MultiSelectItem = styled.div`
  cursor: pointer;
  transition: background-color 0.2s;
  padding: 10px 12px;
  height: 40px;
  display: flex;
  align-items: center;
  width: 100%;
  white-space: nowrap;

  .checkbox {
    accent-color: ${colors.periwinkle};
  }

  &:hover {
    background-color: ${colors.lightGrey};
  }

  label {
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    cursor: pointer;
  }

  input {
    margin-right: 8px;
  }
`;
